import { render, staticRenderFns } from "./ProgramDirection.vue?vue&type=template&id=5738fb63"
import script from "./ProgramDirection.vue?vue&type=script&lang=js"
export * from "./ProgramDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports